import api from "@client/content/lib/api";
import { type ModuleApiInfo } from "@client/content/selectors";
import { type HttpApiResponse } from "@client/types/Api";
import { type Leaderboard } from "./types";

export default {
  apply: async (
    apiInfo: ModuleApiInfo,
    data: Leaderboard.Api.ApplyRequest
  ): Promise<HttpApiResponse<Leaderboard.Api.ApplyResponse>> =>
    api.post(apiInfo, `/api/site/v1/modules/leaderboard/apply`, data),
  getIncentive: (
    apiInfo: ModuleApiInfo,
    incentiveId: string
  ): Promise<HttpApiResponse<Leaderboard.Api.GetIncentiveResponse>> =>
    api.get(apiInfo, `/api/site/v1/modules/leaderboard/incentives/${incentiveId}`),
  getIncentiveItems: (
    apiInfo: ModuleApiInfo,
    incentiveId: string,
    page: number,
    size: number
  ): Promise<HttpApiResponse<Leaderboard.Api.IncentiveLeaderboardItem[]>> =>
    api.get(apiInfo, `/api/site/v1/modules/leaderboard/incentives/${incentiveId}/items`, { page, size }),

  getLaunch: (apiInfo: ModuleApiInfo, launchId: string): Promise<HttpApiResponse<Leaderboard.Api.GetLaunchResponse>> =>
    api.get(apiInfo, `/api/site/v1/modules/leaderboard/launches/${launchId}`),
  getLaunchItems: (
    apiInfo: ModuleApiInfo,
    launchId: string,
    page: number,
    size: number
  ): Promise<HttpApiResponse<Leaderboard.Api.LaunchLeadboardItem[]>> =>
    api.get(apiInfo, `/api/site/v1/modules/leaderboard/launches/${launchId}/items`, { page, size }),

  submitVote: async (
    apiInfo: ModuleApiInfo,
    data: Leaderboard.Api.SubmitVoteRequest
  ): Promise<HttpApiResponse<Leaderboard.Api.SubmitVoteResponse>> =>
    api.post(apiInfo, `/api/site/v1/modules/leaderboard/vote`, data)
};
